module.exports = __webpack_public_path__ + "img/cavalier-challenge-1-tablet_f66df4b82c4e36ba8886bb0481b3683b.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/cavalier-challenge-1-tablet.jpg
// module id = 261
// module chunks = 0